import { v4 as uuidv4 } from "uuid";
let listeners = [];
export function useListenerService() {
  const localListeners = [];
  const removeLocalListeners = () => {
    localListeners.forEach((listener) => {
      removeListener(listener.id);
    });
  };
  const removeLocalListenersWithEvent = (event) => {
    localListeners.forEach((listener) => {
      if (listener.event === event) {
        removeListener(listener.id);
      }
    });
  };
  const addListener = (event, callback) => {
    const listener = {};
    listener.event = event;
    listener.callback = callback;
    listener.id = uuidv4();
    listeners.push(listener);
    localListeners.push(listener);
    return listener.id;
  };
  const removeListener = (id) => {
    listeners = listeners.filter((listener) => listener.id !== id);
  };
  const notify = (key, data) => {
    listeners.forEach((listener) => {
      if (listener.event === key) {
        listener.callback(data);
      }
    });
  };
  return {
    removeLocalListeners,
    removeLocalListenersWithEvent,
    addListener,
    removeListener,
    notify
  };
}
